export enum AuthMode {
    Legacy = "Legacy",
    RefreshToken = "RefreshToken"
}

export interface IApplication {
    id: string;
    name: string;
    redirectUri: string;
    userEditUri?: string;
    secretKey?: string;
    authMode: AuthMode;
    webhookEnabled?: boolean;
    webhookUrl?: string;
    webhookGeneratedSecret?: string;
}